var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.693,2.671h0c4.278,0,7.752,3.474,7.752,7.752h0c0,4.278-3.474,7.752-7.752,7.752H3.941v-7.752c0-4.278,3.474-7.752,7.752-7.752Z",
    transform: "translate(-3.945 11.321) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.693,
    cy: 10.423,
    r: 2.645
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.777342bb1950617a178581b4cea436cf.svg";
export { ForwardRef as ReactComponent };